import React from 'react';
import { getClearButtonWrapper, parseRenderOptions } from './utils';
import { FieldWrapper } from './FieldWrapper';
import classNames from 'classnames';

const DateTimeComponent = ({ inputType, renderOptions, ...props }) => {
  // Get wrapper information if clear button can be visible
  const {
    Tag,
    props: tagProps,
    content,
  } = getClearButtonWrapper(renderOptions, props);

  return (
    <FieldWrapper {...props} renderOptions={renderOptions}>
      <Tag {...tagProps}>
        <input
          ref={props.focusRef}
          className={classNames('form-control', renderOptions.fieldClassName, {
            'form-control-sm': renderOptions.size === 'sm',
            'is-invalid': renderOptions.hasErrors,
            'has-btn': renderOptions.hasClear && !!props.value,
            'is-empty': !props.value,
          })}
          type={inputType}
          id={props.id}
          name={props.name}
          value={props.value}
          onBlur={props.onBlur}
          onChange={props.onChange}
          onFocus={props.onFocus}
          disabled={!props.enabled}
          form={props.form}
        />
        {content}
      </Tag>
    </FieldWrapper>
  );
};

/******************************************************************************
 * Date Field
 ******************************************************************************/

export const DateField = props => {
  const renderOptions = parseRenderOptions(props);
  return (
    <DateTimeComponent
      inputType="date"
      renderOptions={renderOptions}
      {...props}
    />
  );
};

export const DateFilter = props => {
  const renderOptions = parseRenderOptions(props, null, {
    clear: true,
    floating: true,
    size: 'sm',
  });
  return (
    <DateTimeComponent
      inputType="date"
      renderOptions={renderOptions}
      {...props}
    />
  );
};

/******************************************************************************
 * Datetime Field
 ******************************************************************************/

export const DatetimeField = props => {
  const renderOptions = parseRenderOptions(props);
  return (
    <DateTimeComponent
      inputType="datetime-local"
      renderOptions={renderOptions}
      {...props}
    />
  );
};

/******************************************************************************
 * Time Field
 ******************************************************************************/

export const TimeField = props => {
  const renderOptions = parseRenderOptions(props);
  return (
    <DateTimeComponent
      inputType="time"
      renderOptions={renderOptions}
      {...props}
    />
  );
};
